import dynamic from 'next/dynamic';

export default dynamic(() => import('./StaticDatePickerInternal'), { ssr: false });
